export const SIGNIN_USER = 'SIGNIN_USER'
export const SIGNOUT_USER = 'SIGNOUT_USER'
export const SWITCH_COMPANY = 'SWITCH_COMPANY'
export const ADD_SIGN_IN_AS = 'ADD_SIGN_IN_AS'
export const REMOVE_SIGN_IN_AS = 'REMOVE_SIGN_IN_AS'
